// extracted by mini-css-extract-plugin
export var hideEditor = "_rv-2";
export var infoIcon = "_rv-3";
export var label = "_rv-1";
export var labelContainer = "_rv-0";
export var readonlyText = "_rv-4";